/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Utils')
    .directive('accActionsMenu', [function() {

        return {
            replace: true,
            transclude: true,
            template: '<div class="btn-group pull-right">\
                <a class="btn btn-sm btn-acr dropdown-toggle" data-toggle="absolute-dropdown">\
                    <strong>{{ "Actions" | translate }}</strong>\
                        <span class="caret"></span>\
                    </a>\
                        <ul class="dropdown-menu" ng-transclude>\
                        </ul>\
                    </div>'
        }
    } ]);

